import React from 'react';
import styles from './Footer.module.css'; // Importă fișierul CSS Modules
import omdLogo from '../assets/omd.png'; // Asigură-te că ai omd.png în src/assets/

function Footer() {
	return (
		<footer className={styles.footerContainer}>
			<p className={styles.copyright}>
				© {new Date().getFullYear()} Created by
				<span className={styles.spacer}></span>
				<span className={styles.omdBox}>
					<span className={styles.red}>O</span>
					<span className={styles.blue}>M</span>
					<span className={styles.green}>D</span>
				</span>
			</p>
		</footer>
	);
}

export default Footer;
